<div  class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Scheduling for Date {{inner_Record.persianDate}}</h5>


    <button type="button"
      (click)="openModal_LetterRequestCustomer(templateLetterRequestCustomer)" class="btn btn-danger"
      style="margin-right: 5px;"> Select Outgoing Letter <i class="fa fa-vcard"></i> </button>

    <br />
    <br />

    <div [hidden]="Selected_DataList_LetterRequestCustomer.id==0">

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" disabled value="{{Selected_DataList_LetterRequestCustomer.code}}" />
        </div>
        <div class="form-group col-md-8">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" disabled value="{{Selected_DataList_LetterRequestCustomer.customer}}" />
        </div>
      </div>

      <div>

        <h5> Scheduling </h5>

        <br />

        <form [formGroup]="ScheduleForm" (submit)="ScheduleForm_Submit()">

          <input  type="hidden" formControlName="id" />

          <div class="row">
            <div class="form-group col-md-5">
              <label for="exampleInputEmail1"> Date </label>
              <input type="text" disabled value="{{inner_Record.persianDate}}"  placeholder="Type here..."
                class="form-control" />
              
            </div>
            <div class="form-group col-md-2">
              <label for="exampleInputEmail1"> Start Time </label>
              <select class="custom-select" formControlName="startHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="exampleInputEmail1"> End Time </label>
              <select class="custom-select" formControlName="endHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> Publish Approved Critical Comments </label>
              <select class="custom-select" formControlName="comment">
                <option value="1"> Yes </option>
                <option value="0"> No </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Description </label>
              <textarea class="form-control" formControlName="dsc" placeholder="Type here...">
              </textarea>
            </div>

          </div>

          <button  type="submit" [disabled]="!ScheduleForm.valid" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Date </button>

          <button type="button" *ngIf="!ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa  fa-eye"></i> Show Deleted Items </button>

          <button type="button" *ngIf="ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa  fa-eye-slash"></i> Hide Deleted Items </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="Schedule_DataList.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Time</th>
                <th>Description</th>
                <th>Publish Comments</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of Schedule_DataList">
                <tr *ngIf="(ShowDelete_Schedule || item.del==false)">
                  <td>{{Schedule_DataList.indexOf(item)+1}}</td>
                  <td>{{item.persianDate}}</td>
                  <td>From {{item.startDate}} to {{item.endDate}}</td>
                  <td>{{item.dsc}}</td>
                  <td>
                    <p *ngIf="item.comment==1">Yes</p>
                    <p *ngIf="item.comment==0">No</p>
                  </td>
                  <td style="cursor: pointer;"
                    *ngIf="item.status!=true && item.del==false ">

                    <button type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration,item)"
                      class="btn btn-danger" style="margin-right: 5px;"> Search Calibration Technicians <i
                        class="fa fa-user-circle-o"></i> </button>

                    <button type="button" (click)="openModal_DeviceBehfa(templateDeviceBehfa,item)"
                      class="btn btn-warning left"> Select Behfa Equipment <i class="fa fa-building"></i> </button>


                    <a style="cursor: pointer;" (click)="ScheduleForm_Delete(Schedule_DataList.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>



                  <td style="cursor: pointer;" *ngIf="item.del==true">
                    <p style="color: red" *ngIf="item.done==null">Deleted</p>
                    <p style="color: red" *ngIf="item.done==false">Assignment Cancelled</p>
                    <p style="color: green" *ngIf="item.done==true">Assignment Completed</p>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                </tr>

                <tr *ngIf="item.expert.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #396c9b; color: white;">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Last Name</th>
                          <th>National ID</th>
                          <th>Mobile Number</th>
                          <th>Father's Name</th>
                          <th>Supervisor</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.expert">
                          <td>{{item.expert.indexOf(detail)+1}}</td>
                          <td>{{detail.name}}</td>
                          <td>{{detail.familly}}</td>
                          <td>{{detail.melicode}}</td>
                          <td>{{detail.shomareh_Hamreh}}</td>
                          <td>{{detail.name_Pedar}}</td>
                          <td>
                            <p *ngIf="detail.seleted">Yes</p>
                            <p *ngIf="!detail.seleted">No</p>
                          </td>
                          <td style="cursor: pointer;">

                            <a *ngIf="!detail.seleted && detail.del==false" style="cursor: pointer;"
                              (click)="Change_Seleted_ExpertCalibration_Record(item,item.expert.indexOf(detail))"
                              class="dropdown-item"><i class="fa fa-check"></i> Supervisor </a>

                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="ExpertCalibration_Delete(item.expert.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>

                            <p *ngIf="detail.del==true">Deleted</p>
                            <i *ngIf="detail.sms" class="fa fa-envelope" style="color: blue;"></i>
                          </td>

                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

                <tr *ngIf="item.deviceBehfa.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #9b5539; color: white;">
                        <tr>
                          <th>#</th>
                          <th>System ID</th>
                          <th>Description</th>
                          <th>Manufacturer</th>
                          <th>Model</th>
                          <th>Code BEHFA</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.deviceBehfa">
                          <td>{{item.deviceBehfa.indexOf(detail)+1}}</td>
                          <td>{{detail.code}}</td>
                          <td class="EnglishClm">{{detail.description}}</td>
                          <td class="EnglishClm">{{detail.manufacturer}}</td>
                          <td class="EnglishClm">{{detail.model}}</td>
                          <td class="EnglishClm">{{detail.codeBEHFA}}</td>
                          <td style="cursor: pointer;">
                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="DeviceBehfa_Delete(item.deviceBehfa.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>

                            <p *ngIf="detail.del==true">Deleted</p>
                          </td>

                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

              </ng-container>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing && !canEditMore"  (click)="openModal_Code(templateCode)" type="button"
          class="btn btn-success" style="margin-right: 5px;"> <i class="fa fa-plus-circle"></i> Apply Schedule </button>

    </div>



  </div>
</div>


<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Letter Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Subject </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Letter Type</th>
              <th>Customer Name</th>
              <th>Letter Subject </th>
              <th>Recipient Name</th>
              <th>Recipient Position</th>
              <th>Sender User</th>
              <th>Recipient User</th>
              <th>Status</th>
              <th>Message</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]="Proccessing_Schedule.persianDate"
      [inner_SeletedDeviceBehfa]="this.Proccessing_Schedule.deviceBehfa"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Calibration Technician List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Are you sure you want to save this schedule? </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-footer">

    <button type="button"  class="btn btn-success" (click)="SubmitAddNewLetter()">Yes, Save</button>
    <button type="button" class="btn btn-danger" (click)="modalRef.hide()">Close</button>
  </div>
</ng-template>